export default function isObject(obj) {
  return obj === Object(obj);
}
